import React from "react";
function Oracle_SQL() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Oracle SQL </h1>
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/oracle.png")} alt="" />
          </div>
          <div className="heading">
            <h1>SQL – 11g SQL</h1>
            <p>
              SQL – 11g & 12c SQL course offers students a lecture/lab intensive
              environment on Oracle’s Data Server Technology. The class covers
              the concepts of both relational and object relational databases
              and the use of SQL. The student will learn how to write simple to
              complex queries along with being able to modify database objects
              through SQL. Advanced technique such as ROLLUP, CUBE, set
              operators and creation of user-defined datatypes discussed
            </p>

            <h3>Course Description –</h3>

            <h4>Introduction</h4>
            <ul>
              <li>List the Oracle Database 11g Main Features</li>
              <li>
                An Overview of: components, internet platform, apps server and
                developer suite
              </li>
              <li>
                Describe Relational and Object Relational Database Designs
              </li>
              <li>Review the System Development Life Cycle</li>
              <li>Define the term Data Models</li>
              <li>Describe different means of Sorting Data</li>
              <li>Show how Multiple Tables can be related</li>
              <li>Describe how SQL Communicates to the Database</li>
            </ul>
            <h4>Writing SQL SELECT Statements</h4>
            <ul>
              <li>Define projection, selection, and join terminology</li>
              <li>Review the basic SQL SELECT statement syntax</li>
              <li>Select all columns using a wildcard notation from a table</li>
              <li>
                State simple rules and guidelines for writing SQL statements
              </li>
              <li>Write a query containing the arithmetic operators</li>
              <li>
                Create a character expression with the concatenation operator
              </li>
              <li>Using the iSQL*Plus Environment</li>
              <li>SQL statements versus iSQL*Plus commands</li>
            </ul>
            <h4>Restricting and Sorting Data</h4>
            <ul>
              <li>Limit rows using a selection</li>
              <li>Using the WHERE clause to retrieve specific rows</li>
              <li>Using the comparison conditions in the WHERE clause</li>
              <li>Use the LIKE condition to compare literal values</li>
              <li>List the logical conditions AND, OR, NOT</li>
              <li>Describe the rules of precedence for the conditions</li>
              <li> Sort rows with the ORDER BY clause </li>
              <li>
                Use ampersand substitution in iSQL*Plus to restrict and sort
                output at run time
              </li>
            </ul>
            {/*  */}
            <h4>Using Single-Row Functions to Customise Output</h4>
            <ul>
              <li>
                Show the differences between single row and multiple row SQL
                functions
              </li>
              <li>
                Categorise the character functions into case manipulation and
                character manipulation types
              </li>
              <li>
                Use the character manipulation functions in the SELECT and WHERE
                clauses
              </li>
              <li>Explain and use the DATE and numeric functions</li>
              <li>
                Use the SYSDATE function to retrieve the current date in the
                default format
              </li>
              <li>
                Introduce the DUAL table as a means to view function results
              </li>
              <li>
                List the rules for applying the arithmetic operators on dates
              </li>
              <li>
                Use the arithmetic operators with dates in the SELECT clause
              </li>
            </ul>
            {/*  */}
            <h4>Reporting Aggregated Data Using the Group Functions</h4>
            <ul>
              <li>Describe and categorize the group functions</li>
              <li>Use the group functions</li>
              <li>Utilize the DISTINCT keyword with the group functions</li>
              <li>Describe how nulls are handled with the group functions</li>
              <li>Create groups of data with the GROUP BY clause</li>
              <li>Group data by more than one column</li>
              <li>Avoid illegal queries with the group functions</li>
              <li>Exclude groups of data with the HAVING clause</li>
            </ul>
            {/*  */}
            <h4>Displaying Data From Multiple Tables</h4>
            <ul>
              <li>Identify Types of Joins</li>
              <li>Retrieve Records with Natural Joins</li>
              <li>
                Use Table Aliases to write shorter code and explicitly identify
                columns from multiple tables
              </li>
              <li>
                Create a Join with the USING clause to identify specific columns
                between tables
              </li>
              <li>
                Use the ON clause to specify arbitrary conditions or specify
                columns to Join
              </li>
              <li>
                Create a Three-way join with the ON clause to retrieve
                information from 3 tables
              </li>
              <li>List the Types of Outer Joins LEFT, RIGHT, and FULL</li>
              <li>Generating a Cartesian Product</li>
            </ul>
            {/*  */}
            <h4>Using Sub Queries to solve Queries</h4>
            <ul>
              <li>
                List the syntax for sub queries in a SELECT statements WHERE
                clause
              </li>
              <li>List the guidelines for using sub queries</li>
              <li>Describe the types of sub queries</li>
              <li>
                Execute single row sub queries and use the group functions in a
                sub query{" "}
              </li>
              <li>Identify illegal statements with sub queries</li>
              <li>Execute multiple row sub queries</li>
              <li>
                Analyze how the ANY and ALL operators work in multiple row sub
                queries
              </li>
            </ul>
            {/*  */}
            <h4>Using the SET Operators</h4>
            <ul>
              <li>
                Use the UNION operator to return all rows from multiple tables
                and eliminate any duplicate rows
              </li>
              <li>
                Use the UNION ALL operator to return all rows from multiple
                tables{" "}
              </li>
              <li>Describe the INTERSECT operator </li>
              <li>Use the INTERSECT operator</li>
              <li>Explain the MINUS operator</li>
              <li>Use the MINUS operator </li>
              <li>List the SET operator guidelines</li>
              <li>Order results when using the UNION operator</li>
            </ul>
            {/*  */}
            <h4>Manipulating Data</h4>
            <ul>
              <li>Write INSERT statements to add rows to a table</li>
              <li>Copy rows from another table</li>
              <li>Create UPDATE statements to change data in a table</li>
              <li>Generate DELETE statements to remove rows from a table</li>
              <li>Use a script to manipulate data</li>
              <li>Save and discard changes to a table through transaction processing</li>
              <li>Show how read consistency works</li>
              <li>Describe the TRUNCATE statement</li>
            </ul>
            {/*  */}
            <h4>Using DLL Statement to create and Manage Tables</h4>
            <ul>
              <li>List the main database objects and describe the naming rules for database objects</li>
              <li>Introduce the schema concept</li>
              <li>Display the basic syntax for creating a table and show the DEFAULT option</li>
              <li>Explain the different types of constraints</li>
              <li>Show resulting exceptions when constraints are violated with DML statements</li>
              <li>Create a table with a sub query</li>
              <li>Describe the ALTER TABLE functionality</li>
              <li>Remove a table with the DROP statement and Rename a table</li>
            </ul>
            {/*  */}
            <h4>
            Creating the Schema Objects
            </h4>
            <ul>
              <li>Categorize simple and complex views and compare them</li>
              <li>Create a view</li>
              <li>Retrieve data from a view</li>
              <li>Explain a read-only view</li>
              <li>List the rules for performing DML on complex views</li>
              <li>Create a sequence</li>
              <li>List the basic rules for when to create and not create an index</li>
              <li>Create a synonym</li>
            </ul>
            {/*  */}
            <h4>
            Managing Objects with Data Dictionary Views
            </h4>
            <ul>
              <li>Describe the structure of each of the dictionary views</li>
              <li>List the purpose of each of the dictionary views</li>
              <li>Write queries that retrieve information from the dictionary views on the schema objects</li>
              <li>Use the COMMENT command to document objects</li>
            </ul>
            {/*  */}
            <h4>
            Controlling User Access
            </h4>
            <ul>
              <li>Controlling User Access</li>
              <li>System versus Objects Privileges</li>
              <li>Using Roles to define user groups</li>
              <li>Changing Your Password</li>
              <li>Granting Object Privileges</li>
              <li>Confirming Privileges Granted</li>
              <li>Revoking Object Privileges</li>
              <li>Using Database Links</li>
            </ul>
            {/*  */}
            <h4>
            Manage Schema Objects
            </h4>
            <ul>
              <li>Using the ALTER TABLE statement</li>
              <li>Adding a Column</li>
              <li>Modifying a Column</li>
              <li>Dropping a Column, Set Column UNUSED</li>
              <li>Adding, Enabling and Disabling Constraints</li>
              <li>Creating Function-Based Indexes</li>
              <li>Performing FLASHBACK operations</li>
              <li>External Tables</li>
            </ul>
            {/*  */}
            <h4>
            Manipulating Large Data Sets
            </h4>
            <ul>
              <li>Using the MERGE Statement</li>
              <li>Performing DML with Sub queries</li>
              <li>Performing DML with a RETURNING Clause</li>
              <li>Overview of Multi-table INSERT Statements</li>
              <li>Tracking Changes in DML</li>
            </ul>
            {/*  */}
            <h4>
            Generating Reports by Grouping Related Data
            </h4>
            <ul>
              <li>Overview of GROUP BY Clause</li>
              <li>Overview of Having Clause</li>
              <li>Aggregating data with ROLLUP and CUBE Operators</li>
              <li>Determine subtotal groups using GROUPING Functions</li>
              <li>Compute multiple groupings with GROUPING SETS</li>
              <li>Define levels of aggregation with Composite Columns</li>
              <li>Create combinations with Concatenated Groupings</li>
            </ul>
            {/*  */}
            <h4>
            Managing Data From Diffrent Time Zone
            </h4>
            <ul>
              <li>Time Zones</li>
              <li>Using date and time functions</li>
              <li>Identifying TIMESTAMP Data Types</li>
              <li>Differentiating between DATE and TIMESTAMP</li>
              <li>Performing Conversion Operations</li>
            </ul>
            {/*  */}
            <h4>
            Hierarchical Retrieval
            </h4>
            <ul>
              <li>Sample Data from the EMPLOYEES Table</li>
              <li>The Tree Structure of Employee data</li>
              <li>Hierarchical Queries</li>
              <li>Ranking Rows with LEVEL</li>
              <li>Formatting Hierarchical Reports Using LEVEL and LPAD</li>
              <li>Pruning Branches with the WHERE and CONNECT BY clauses</li>
            </ul>
            {/*  */}
          <h4>
          Regular Expression Support
          </h4>
          <ul>
            <li>Describing simple and complex patterns for searching and manipulating data</li>
            <li>Regular Expression Support Overview</li>
          </ul>
          {/*  */}
          <h4>
            
Searching Data Using Advanced Sub Queries
          </h4>
          <ul>
            <li>Sub query Overview</li>
            <li>Using a Sub query</li>
            <li>Comparing several columns using Multiple-Column Sub queries</li>
            <li>Defining a Data source Using a Sub query in the FROM Clause</li>
            <li>Returning one Value using Scalar Sub query Expressions</li>
            <li>Performing ROW by-row processing with Correlated Sub queries</li>
            <li>Reusing query blocks using the WITH Clause</li>
          </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Oracle_SQL;
